import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import StatsCard from "components/StatsCard";
import { ReactComponent as VideoStatsIcon } from "assets/img/icons/video-stats.svg";
import TeamVideoStatsDetails from "./TeamVideoStatsDetails";

export default ({ team_id, showPublishVideo = true }) => {
  const [stats, setStats] = useState({});
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detailsOpened, setDetailsOpened] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await TeamService.getTeamVideoStats(team_id, time);

        setStats(response?.data?.data);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [team_id, time]);

  return (
    <>
      <StatsCard
        title="Team Video Stats"
        backgroundClass="card-red"
        Icon={VideoStatsIcon}
        loading={loading}
        time={time}
        stats={stats}
        setTime={setTime}
        onDetailsOpen={() => setDetailsOpened(true)}
        onDetailsClosed={() => setDetailsOpened(false)}
        statsClass="mt-30"
      >
        <TeamVideoStatsDetails
          showPublishVideo={showPublishVideo}
          team_id={team_id}
          time={time}
          setTime={setTime}
          opened={detailsOpened}
        />
      </StatsCard>
    </>
  );
};
